// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__cJXxR","new-offer-tile":"styles_new-offer-tile__FIrH1","newOfferTile":"styles_new-offer-tile__FIrH1"};